import { http, HttpResponse } from "msw";

import { DeploymentUser, OrgRole } from "@protos/deployment/v1/deployment";

export const TEST_MEMBERS: DeploymentUser[] = [
  {
    id: 186,
    orgRole: OrgRole.MEMBER,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2021-10-22T05:13:18.224Z"),
    groups: [],
    name: "Emma Jin",
    login: "emjin",
    email: "emma@semgrep.dev",
    avatarUrl: "",
    active: true,
  },
  {
    id: 264,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2023-06-04T15:52:20.638Z"),
    groups: [],
    name: "Adam Berman",
    login: "adamberman",
    email: "adam@semgrep.dev",
    avatarUrl: "",
    active: false,
  },
  {
    id: 266,
    orgRole: OrgRole.MEMBER,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2021-02-02T20:27:54.501Z"),
    groups: [],
    name: "Yoann Padioleau",
    login: "aryx",
    email: "pad@returntocorp.com",
    avatarUrl: "",
    active: false,
  },
  {
    id: 272,
    orgRole: OrgRole.MEMBER,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2021-02-02T20:27:54.501Z"),
    groups: [],
    name: "",
    login: "AzureUmbra",
    email: "",
    avatarUrl: "",
    active: true,
  },
  {
    id: 274,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2023-02-11T05:22:15.701Z"),
    groups: [],
    name: "Isaac Evans",
    login: "ievans",
    email: "isaac@semgrep.dev",
    avatarUrl: "",
    active: false,
  },
  {
    id: 278,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2021-07-22T06:09:23.963Z"),
    groups: [],
    name: "Daghan Altas",
    login: "daghan",
    email: "daghan@semgrep.dev",
    avatarUrl: "",
    active: false,
  },
  {
    id: 280,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2023-11-21T12:11:14.996Z"),
    groups: [],
    name: "Drew Dennison",
    login: "DrewDennison",
    email: "drew@semgrep.com",
    avatarUrl: "",
    active: false,
  },
  {
    id: 287,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2021-04-16T07:43:38.314Z"),
    groups: [],
    name: "Clint Gibler",
    login: "clintgibler",
    email: "clint@semgrep.dev",
    avatarUrl: "",
    active: false,
  },
  {
    id: 288,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2023-12-06T19:05:27.435Z"),
    groups: [],
    name: "Brendon Go",
    login: "brendongo",
    email: "brendon@semgrep.dev",
    avatarUrl: "",
    active: true,
  },
  {
    id: 290,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2020-11-01T00:00:00.000Z"),
    lastUpdatedAt: new Date("2023-08-16T18:26:15.789Z"),
    groups: [],
    name: "Clara McCreery",
    login: "chmccreery",
    email: "clara@semgrep.dev",
    avatarUrl: "",
    active: true,
  },
  {
    id: 1478,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2022-06-06T22:19:23.624Z"),
    lastUpdatedAt: new Date("2022-06-09T21:40:36.266Z"),
    groups: [],
    name: "",
    login: "benkettle",
    email: "ben@r2c.dev",
    avatarUrl: "",
    active: true,
  },
  {
    id: 2478,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2022-07-07T14:02:58.130Z"),
    lastUpdatedAt: new Date("2023-12-06T16:53:57.264Z"),
    groups: [],
    name: "Tom Petr",
    login: "tpetr",
    email: "tom@semgrep.dev",
    avatarUrl: "",
    active: true,
  },
  {
    id: 2578,
    orgRole: OrgRole.ADMIN,
    authentication: ["github"],
    since: new Date("2022-07-12T23:52:42.552Z"),
    lastUpdatedAt: new Date("2023-05-04T22:28:27.166Z"),
    groups: [],
    name: "Julia Teitelbaum",
    login: "juliat",
    email: "julia@semgrep.dev",
    avatarUrl: "",
    active: true,
  },
  {
    id: 2579,
    orgRole: OrgRole.MEMBER,
    authentication: ["sso"],
    since: new Date("2022-07-12T23:52:42.552Z"),
    lastUpdatedAt: new Date("2023-05-04T22:28:27.166Z"),
    groups: [],
    name: "Julia SSO",
    login: "juliatsso",
    email: "julia@semgrep.dev",
    avatarUrl: "",
    active: true,
  },
];

export const memberHandlersStatic = [
  http.get("*/api/agent/deployments/:deploymentId/users", () =>
    HttpResponse.json({ users: TEST_MEMBERS })
  ),
  http.patch(
    "*/api/agent/deployments/:deploymentId/users/:userId/roles",
    () => {
      return new HttpResponse(null, {
        status: 200,
      });
    }
  ),
  http.delete("*/api/agent/deployments/:deploymentId/users/:userId", () => {
    return new HttpResponse(null, {
      status: 200,
    });
  }),
];
